import React from 'react'
import i18next from 'i18next';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { connect } from 'react-redux'
import { toast } from 'react-toastify';
import { displayDialogQrcodeLinkToApp } from '../store/appNavigation/actions';
import QRCode from 'qrcode.react';
import { MdCameraAlt, MdAddToHomeScreen, MdVpnKey, MdContentCopy, MdEmail } from 'react-icons/md';
import logoEIV from '../resources/logo65x65.png';

const getLocationWithoutParameters = () => {
	const currentUrl = new URL(window.location.href);
	return currentUrl.origin + currentUrl.pathname;
}
const linkToApp = getLocationWithoutParameters();

const copyLinkToClipboard = async () => {
	try {
		await navigator.clipboard.writeText(linkToApp);
		toast.info("Link in die Zwischenablage kopiert");
	} catch (err) {
		toast.warning("Der Link ließ sich nicht kopieren");
	}
}

// Vorgefertigte Nachricht: weitergereicht wird die App unter Veranstaltern, deshalb die
// Arbeitsschritte und der Hinweis auf VNR und Kennwort - ohne die beiden nuetzt der Link
// nichts, und die Rueckfrage danach kommt sonst hinterher.
const sendEmail = () => {
	const subject = encodeURIComponent('FOBI Punktemeldung – Fortbildungspunkte online melden');
	const body = encodeURIComponent(`Hallo,

zum Melden der Fortbildungspunkte Ihrer Teilnehmer gibt es die FOBI Punktemeldung:

• Teilnahmen über die EFN erfassen, auch mehrere auf einmal
• EFN per Barcode oder QR-Code scannen
• Punkte für Referent, Moderation und wissenschaftliche Leitung angeben
• Gemeldete Teilnahmen jederzeit im Protokoll nachsehen

Link: ${linkToApp}

Zum Hinzufügen einer Veranstaltung brauchen Sie deren VNR und das zugehörige
Kennwort – beides erhalten Sie von der anerkennenden Ärztekammer.
Die Anwendung läuft im Browser und lässt sich auf dem Handy zum Startbildschirm
hinzufügen.

Viele Grüße`);

	window.open(`mailto:?subject=${subject}&body=${body}`, '_blank');
}

const QRCodeLinkToAppDialog = (props) => {
	const { isOpen, onClose } = props
	return(
		<Modal centered={true} isOpen={isOpen} toggle={ () => onClose() } contentClassName="share-dialog-card">
		<ModalBody className="p-0">
			<div className="share-header text-center p-4 position-relative">
				<button type="button" className="btn-close btn-close-white position-absolute top-0 end-0 m-3"
					aria-label={i18next.t('close')} onClick={ () => onClose() }></button>
				{/* Dasselbe Zeichen wie auf dem Startbildschirm: hier sieht man, was beim
				    Gegenueber ankommt. Der QR-Code steht ohnehin gross darunter. */}
				<img src={logoEIV} alt="" className="share-logo mb-3" />
				<div className="h4 fw-bold mb-1">FOBI Punktemeldung teilen</div>
				<div className="small opacity-75">QR-Code scannen oder Link kopieren</div>
			</div>

			<div className="p-4">
				<div className="d-flex justify-content-center mb-4">
					{/* Der weisse Rahmen bleibt auch im Dunkelmodus weiss: Lesegeraete
					    brauchen dunkle Module auf hellem Grund samt Ruhezone. */}
					<div className="qr-code-wrapper">
						<QRCode value={linkToApp} size={160} level="H" />
					</div>
				</div>

				<div className="url-card d-flex align-items-center p-3 mb-4">
					<div className="flex-grow-1 me-3 overflow-hidden">
						<div className="small text-body-secondary mb-1">Adresse der Anwendung</div>
						<div className="text-truncate">{linkToApp}</div>
					</div>
					<button type="button" className="btn btn-primary btn-sm share-icon-btn"
						title="Link in die Zwischenablage kopieren" onClick={copyLinkToClipboard}>
						<MdContentCopy size="1.1em" />
					</button>
				</div>

				<div className="text-center mb-4">
					<div className="mb-2"><MdCameraAlt className="me-2 text-primary" size="1.2em" />QR-Code mit der Kamera scannen</div>
					<div className="mb-2"><MdAddToHomeScreen className="me-2 text-primary" size="1.2em" />Zum Startbildschirm hinzufügen</div>
					<div><MdVpnKey className="me-2 text-primary" size="1.2em" />Melden geht mit VNR und Kennwort der Veranstaltung</div>
				</div>

				<div className="email-card d-flex align-items-center p-3">
					<div className="flex-grow-1 me-3">
						<div>Kolleginnen und Kollegen einladen</div>
						<div className="small text-body-secondary">Link mit vorbereiteter Nachricht senden</div>
					</div>
					<button type="button" className="btn btn-primary btn-sm share-icon-btn"
						title="App-Link per E-Mail senden" onClick={sendEmail}>
						<MdEmail size="1.1em" />
					</button>
				</div>
			</div>
		</ModalBody>
		<ModalFooter className="border-0 pt-0">
			<button type="button" className="btn btn-outline-secondary w-100" onClick={ () => onClose() }>
				{i18next.t('close')}
			</button>
		</ModalFooter>
	</Modal>
	)
}
const mapStateToProps = (state) => {
	return {
		isOpen: state.appNavigation.displayDialogQrcodeLinkToApp
	}
} 
const mapDispatchToProp = (dispatch) => ({
	onClose: () => dispatch(displayDialogQrcodeLinkToApp(false)),
})
export default connect(mapStateToProps, mapDispatchToProp)(QRCodeLinkToAppDialog)
